import {Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import React from "react";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
    gridNotas: {
        margin: 0,
        width: '100%',
        flexGrow: 0,
        display: 'flex',
        justifyContent: 'space-between',
       // height: '20mm',
        paddingLeft: '10mm',
        paddingRight: '10mm',
        flexDirection: 'row',
        // backgroundColor: '#fecc00',
        flexWrap: 'wrap',
        msFlexDirection: "column",
        borderTop: 1,
        borderTopStyle: 'solid',
        borderTopColor: 'beige'

    },


    gridEsq: {
        padding: '5mm',
        width: '50mm'
    },
    gridMeio: {
        display: 'flex',
        width: '60%',

        flexGrow: 1,
        alignItems: 'center'

    },
    gridDir: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center'

    },


}));

const NotasPag = (props) => {
   const {pagina, meio1 } = props;
   const classes = useStyles();

    return (
        <Grid container className={classes.gridNotas}>
           <Typography gutterBottom variant={"caption"}>* O indicador "Com O.S" é relativo ao número de raspagens realizadas.</Typography>
            <Typography gutterBottom variant={"caption"}>* Os indicadores "Uso de Receita" e "Receitas Não Aproveitadas" são relativos ao total de raspagens com O.S.</Typography>
        </Grid>
    );

}

export default (NotasPag)